export default function ServiceArea() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-teal-400 via-teal-500 to-blue-500"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Title */}
        <h2 className="text-5xl md:text-7xl font-bold text-white uppercase leading-tight mb-8">
          PHỤC VỤ TOÀN<br />
          <span className="text-amber-300">VIỆT NAM</span><br />
          VÀ CÁC KHU VỰC LÂN CẬN
        </h2>

        {/* Description */}
        <div className="space-y-3 mb-12">
          <p className="text-white/90 text-lg">
            Thu mua tận nơi tại tất cả tỉnh thành, quận huyện
          </p>
          <p className="text-white/90 text-lg">
            Cam kết có mặt trong vòng <strong className="text-amber-300">30 phút</strong> sau khi nhận cuộc gọi
          </p>
        </div>

        {/* CTA Button */}
        <a href="#contact" className="inline-flex items-center gap-4 bg-gray-900 hover:bg-black text-white px-10 py-5 rounded-full text-base font-bold transition-all whitespace-nowrap shadow-2xl hover:shadow-3xl hover:scale-105 relative">
          <div className="absolute -left-3 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center">
              <i className="ri-map-pin-line text-white text-2xl"></i>
            </div>
          </div>
          <span className="ml-12">XEM KHU VỰC PHỤC VỤ CHI TIẾT</span>
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-2xl"></i>
          </div>
        </a>

        {/* Service Areas List */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Hà Nội</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>TP. Hồ Chí Minh</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Đà Nẵng</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Hải Phòng</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Cần Thơ</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Bình Dương</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Đồng Nai</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-checkbox-circle-fill text-amber-300"></i>
            </div>
            <span>Và nhiều nơi khác</span>
          </div>
        </div>
      </div>
    </section>
  );
}